let translations;
let pending;
let failure;

// Hardcoded English pages do not need the legacy translation dictionary.
// Shared translated components read this during rendering, under route Suspense.
export default function readEnglishTranslations() {
  if (translations) return translations;
  if (failure) throw failure;
  if (!pending) {
    pending = import('@/components/translations/englishTranslations').then(
      module => { translations = module.default; },
      error => { failure = error; },
    );
  }
  throw pending;
}